module.exports = __webpack_public_path__ + "img/orn_peq_left.11d761bc.svg";